// Components
import EditingHelpText from 'components/helpers/EditingHelpText';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import Xup, { ColumnOptions } from 'components/helpers/Xup/Xup';
import { Foundation } from '.generated/templates/Foundation.Items.model';
import ImageWrapper, { SizedImageField } from 'components/helpers/ImageWrapper/ImageWrapper';
import classNames from 'classnames';
import Button from 'components/helpers/Button/Button';
import Heading from 'components/helpers/Heading/Heading';

type NewsCardWithFeedText = Sitecore.Override.ItemEx &
  Foundation.Pages.Fields.BaseArticle & {
    viewAllText: string;
    viewAllUrl: string;
    feedAssignment: string;
  };

export type NewsCardsProps = Sitecore.Override.ComponentBase & {
  fields: {
    newsCards: NewsCardWithFeedText[];
  };
};

const NewsCards = ({ fields, rendering }: NewsCardsProps): JSX.Element => {
  const columns = fields?.newsCards?.length.toString() as ColumnOptions;
  const componentAnchorId = rendering?.uid;
  return (
    <div
      data-component="authorable/article/newscards"
      id={componentAnchorId}
      className="anchorIdIndentifier"
    >
      <EditingHelpText
        condition={!fields.newsCards?.length}
        text="New Cards | No feed selected or no articles in feed. "
      />

      <Xup columns={columns}>
        {fields?.newsCards?.map((newsRelease) => {
          return (
            <li
              key={newsRelease.id}
              className={classNames('flex', 'flex-col', 'h-auto', 'h-full', 'mb-5', 'md:mb-0')}
            >
              <div
                className={classNames(
                  'relative',
                  'w-full',
                  'aspect-[4/3]',
                  'rounded-lg',
                  'overflow-hidden'
                )}
              >
                <ImageWrapper
                  layout="fill"
                  field={
                    newsRelease.fields.imageFeatured?.value?.src
                      ? (newsRelease.fields.imageFeatured as SizedImageField)
                      : (newsRelease.fields.imageFallback as SizedImageField)
                  }
                  imageClass={classNames('w-full', 'h-full', 'object-cover')}
                />
              </div>
              <div
                className={classNames(
                  'flex',
                  'flex-col',
                  'flex-grow',
                  'py-4',
                  'md:py-4',
                  'shrink-0',
                  'text-gray-dark'
                )}
              >
                {newsRelease.feedAssignment && (
                  <div className={classNames('text-sm', 'mb-2')}>{newsRelease.feedAssignment}</div>
                )}
                <Heading
                  headingText={newsRelease.fields.articleTitle}
                  headingClassName={classNames('mb-6', 'font-regular', 'text-gray-darkest')}
                  headingLevel="h3"
                  headingSize="xs"
                  descriptionClassName="mb-8"
                />
                <div
                  className={classNames('mt-auto', 'border-t', 'border-gray', 'pt-6', 'md:pt-3')}
                >
                  <Button
                    field={{
                      value: { href: newsRelease.viewAllUrl, text: newsRelease.viewAllText },
                    }}
                    variant="tertiary"
                  />
                </div>
              </div>
            </li>
          );
        })}
      </Xup>
    </div>
  );
};

export default NewsCards;
